import {useEffect,useRef} from 'react';
import type {User} from 'firebase/auth';
import {accountRequest} from './account-client';
export function useReadingActivity(user:User|null,storyId:string|undefined,finished:boolean|undefined,refresh:()=>void){
 const lastInteraction=useRef(performance.now());
 useEffect(()=>{
  if(!user||!storyId||finished)return;
  let stopped=false,busy=false,sessionId:string|undefined,sequence=0,startKey=crypto.randomUUID(),flushQueued=false;
  const recent=()=>performance.now()-lastInteraction.current<90000;
  const active=()=>document.visibilityState==='visible'&&document.hasFocus()&&recent();
  const interact=()=>{lastInteraction.current=performance.now();};
  const tick=async(final=false)=>{
   if(stopped||(!final&&!active())||(final&&!recent()))return;
   if(busy){flushQueued||=final;return;}
   busy=true;
   try{if(!sessionId){if(final)return;const result=await accountRequest(user,'/api/me/activity',{kind:'start',storyId,startKey});sessionId=result.sessionId;sequence=result.sequence??0;}
    else await accountRequest(user,'/api/me/activity',{kind:'heartbeat',sessionId,sequence:++sequence},{keepalive:final});
   }catch(error){if((error as {status?:number}).status===409){sessionId=undefined;startKey=crypto.randomUUID();}}
   finally{busy=false;if(flushQueued){flushQueued=false;void tick(true);}}
  };
  const focus=()=>{interact();void tick();};
  const visibility=()=>{if(document.visibilityState==='hidden')void tick(true);else focus();};
  const leaving=()=>void tick(true);
  for(const name of ['pointerdown','keydown','scroll'])addEventListener(name,interact,{passive:true,capture:true});
  addEventListener('focus',focus);addEventListener('pagehide',leaving);document.addEventListener('visibilitychange',visibility);
  const interval=setInterval(()=>void tick(),30000);void tick();
  return ()=>{
   // The final update is best effort; the server still bounds credited time.
   if(sessionId&&recent()&&!busy)void accountRequest(user,'/api/me/activity',{kind:'heartbeat',sessionId,sequence:++sequence},{keepalive:true}).catch(()=>{});
   stopped=true;clearInterval(interval);removeEventListener('focus',focus);removeEventListener('pagehide',leaving);document.removeEventListener('visibilitychange',visibility);
   for(const name of ['pointerdown','keydown','scroll'])removeEventListener(name,interact,true);refresh();
  };
 },[user,storyId,finished,refresh]);
}
